<template>
  <div id="home">
    <div>
      <div>
        <h2Title title="订单概况"></h2Title>
        <div class="left-top">
          <div class="item" v-for="todo in todoLists" :key='todo.id' @click="linkPage(todo.type)">
            <span>{{todo.data}}</span>
            <p>{{todo.name}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="loginInfo.userType=='1'">
      <div style="width:50%">
        <h2Title title="司机统计"></h2Title>
        <charts></charts>
      </div>
      <div style="width:50%">
        <h2Title title="区域订单统计"></h2Title>
        <order-map></order-map>
      </div>
    </div>
    <div>
      <div>
        <h2Title title="月度订单统计"></h2Title>
        <histogram></histogram>
      </div>
    </div>
  </div>
</template>

<script>
  import h2Title from "@/page/statistics/template/title.vue";
  import charts from "@/page/statistics/template/charts.vue";
  import histogram from "@/page/statistics/template/histogram.vue";
  import orderMap from "@/page/statistics/template/map.vue";
  import { queryOrderNumTotal } from  "@/api/order/orderinfo"
  import {mapGetters} from "vuex";
  export default {
    name: "index",
    data() {
      return {
        todoLists:[
          {name:'未处理订单',data: 0,type:'1'},
          {name:'今日进行中',data: 0,type:'2'},
          {name:'今日已接订单',data: 0,type:'3'},
          {name:'今日已取消',data: 0,type:'4'},
          {name:'本月累计订单',data: 0,type:'5'},
        ],
        showMask:false,
      }
    },
    created() {
      //未处理订单
      queryOrderNumTotal({type:1}).then(res =>{
        if(res.data.code==0){
          this.todoLists[0].data = res.data.data
        }
      })
      //今日进行中
      queryOrderNumTotal({type:2}).then(res =>{
        if(res.data.code==0){
          this.todoLists[1].data = res.data.data
        }
      })
      //今日已接单
      queryOrderNumTotal({type:3}).then(res =>{
        if(res.data.code==0){
          this.todoLists[2].data = res.data.data
        }
      })
      //今日已取消
      queryOrderNumTotal({type:4}).then(res =>{
        if(res.data.code==0){
          this.todoLists[3].data = res.data.data
        }
      })
      //本月累计订单
      queryOrderNumTotal({type:5}).then(res =>{
        if(res.data.code==0){
          this.todoLists[4].data = res.data.data
        }
      })
    },
    components: {
      h2Title,
      charts,
      histogram,
      orderMap
    },
    computed: {
      ...mapGetters([ "loginInfo"])
    },
    methods: {
      //订单详情页
      linkPage(type){
        let userType = this.loginInfo.userType
        console.log('========='+userType)
        if(userType=='2'){
          this.$router.push({
            path: '/cus/order?type='+type,
          })
        }else{
          this.$router.push({
            path: '/order/manage?type='+type,
          })
        }
      },
      more(){
        this.$router.push({path:'/information'});
      },
      openPage(){
        let guide = this.$router.resolve({
          path: "/guide"
        });
        window.open(guide.href, '_blank');
      }
    }
  };
</script>
<style scoped="scoped">
  #main #home {
    background: transparent;
    box-shadow: none;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  #main .row {
    background: transparent;
    box-shadow: none;
    padding: 0;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;
  }

  #home>div:nth-of-type(1) {
    flex-grow: 1;
  }

  .leftCon {
    width: 355px;
  }

  .left-top {
    display: flex;
    background: #fff;
    height: 104px;
    border-radius: 4px;
    box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
    align-items: center;
    justify-content: space-between;
  }
  @media screen and (min-width: 1920px) {
    .left-top {
      height: 140px;
    }
  }

  .left-top .item {
    flex-grow: 1;
    position: relative;
    cursor: pointer;
  }

  .left-top .item:after {
    content: '';
    position: absolute;
    right: 0;
    top: 7px;
    width: 2px;
    height: 48px;
    background: rgba(234, 234, 234, 1);
  }

  .left-top .item:nth-last-of-type(1):after {
    display: none;
  }

  .left-top span {
    display: block;
    font-size: 30px;
    font-weight: 400;
    color: rgba(255, 134, 121, 1);
    line-height: 42px;
    text-align: center;
  }

  .left-top .item:nth-of-type(2) span {
    color: #27CCC3;
  }

  .left-top .item:nth-of-type(3) span {
    color: #44D38A;
  }

  .left-top .item:nth-of-type(4) span {
    color: #F06565;
  }

  .left-top .item:nth-of-type(5) span {
    color: #678FE6;
  }

  .left-top .item:nth-of-type(6) span {
    color: #E785BC;
  }

  .left-top p {
    font-size: 14px;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
    text-align: center;
    margin-top: 7px;
  }

  .img img {
    margin-top: 10px;
    display: block;
    cursor: pointer;
  }

  .el-link.is-underline:hover:after{
    display: none;
  }
  .shortMenu>>>.el-link--inner {
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
  }
  .Mask{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background:rgba(0,0,0,.2);
    z-index: 8;
  }
</style>
